import './vendor/bootstrap';
import 'slick-carousel';
import './app/forms';
import './app/global';
import './app/inscription-commune';
import './app/profil-commune';
import './app/single-commune';
import './app/candidature-artiste';
import './app/liste-artistes';
import './app/commune-programme-admin';
import initRecaptcha from "./app/forms";

$(function () {
    initRecaptcha();
})



// WEBPACK FOOTER //
// ./src/js/bundle.js